import React from 'react';
import './BottomNav.css';

/* Crisp inline SVG icons (premium, replace emoji) */
const IconSmartcore = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2l8 4.5v9L12 22l-8-6.5v-9L12 2z" />
    <circle cx="12" cy="12" r="3" />
    <path d="M12 9V6M12 18v-3M15 12h3M6 12h3" />
  </svg>
);

const IconMining = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 3c2.5.5 5 2.5 6 5l-3 1c-.7-1.6-2-2.8-4-3.3L14 3z" />
    <path d="M10 3C7.5 3.5 5 5.5 4 8l3 1c.7-1.6 2-2.8 4-3.3L10 3z" />
    <path d="M9.5 9.5l-6 9.5a1.5 1.5 0 002 2l9.5-6" />
  </svg>
);

const IconCoin = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v10M9.5 9.5h3.2a1.8 1.8 0 010 3.6H9.5h3.5a1.8 1.8 0 010 3.6H9.5" transform="translate(0 -1)" />
  </svg>
);

/* Blockchain icon for Buy Node — linked nodes */
const IconNode = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="4" r="2.2" />
    <circle cx="4.5" cy="17" r="2.2" />
    <circle cx="19.5" cy="17" r="2.2" />
    <circle cx="12" cy="12" r="2.2" />
    <path d="M12 6.2v3.6M10.3 13.4l-4 2.2M13.7 13.4l4 2.2" />
  </svg>
);

/* Swap / exchange icon for DEX */
const IconSwap = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 8.5h13l-3.4-3.5M20 15.5H7l3.4 3.5" />
  </svg>
);

const BottomNav = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'smartcore', label: 'Smartcore', Icon: IconSmartcore, color: '#22d3ee' },
    { id: 'mining', label: 'Mining', Icon: IconMining, color: '#fbbf24' },
    { id: 'coin', label: 'Coin', Icon: IconCoin, color: '#34f5c5' },
    { id: 'buynode', label: 'Buy Node', Icon: IconNode, color: '#a855f7', href: 'https://node.smartcore.live/' },
    { id: 'swap', label: 'Swap', Icon: IconSwap, color: '#ec4899', href: 'https://dex.smartcore.live/' },
  ];

  return (
    <nav className="bottom-nav">
      <div className="bottom-nav-container">
        {tabs.map((tab) => {
          const { Icon } = tab;

          // External-link menus (Buy Node, Swap) open their site in a new tab
          if (tab.href) {
            return (
              <a
                key={tab.id}
                href={tab.href}
                target="_blank"
                rel="noopener noreferrer"
                className="bottom-nav-item"
                style={{ '--tab-color': tab.color }}
              >
                <span className="nav-icon"><Icon /></span>
                <span className="nav-label">{tab.label}</span>
              </a>
            );
          }

          return (
            <button
              key={tab.id}
              className={`bottom-nav-item ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => onTabChange(tab.id)}
              style={{ '--tab-color': tab.color }}
            >
              <span className="nav-icon"><Icon /></span>
              <span className="nav-label">{tab.label}</span>
              {activeTab === tab.id && <div className="nav-indicator"></div>}
            </button>
          );
        })}
      </div>
      <div className="bottom-nav-glow"></div>
    </nav>
  );
};

export default BottomNav;
